module.exports = __webpack_public_path__ + "img/yandex-color.cbbc52e1.svg";